/**
 * Resolves a multi-select cell ref into a `UnifiedSelectCellResolution` for
 * the merged table (offer-unified-table, CU-86cbc3r8b). Part of
 * `use-offer-table-multi-select.ts`'s multi-select seam; see that file's
 * own doc comment.
 */
import * as React from 'react';
import { type MultiSelectCellRef, type InventoryAvailabilityPeriod } from '@ooh/screens';
import type { UnifiedSelectCellResolution } from '@ooh/screens';
import {
  resolveOfferMultiSelectCell,
  type buildOfferUnitEntriesGrid,
} from '../lib/offer-availability-mapping';

export interface UseMultiSelectCellResolutionOptions {
  periods: InventoryAvailabilityPeriod[];
  entriesGrid: ReturnType<typeof buildOfferUnitEntriesGrid>;
  mediaUnitIdById: Map<string, number>;
}

export function useMultiSelectCellResolution({
  periods,
  entriesGrid,
  mediaUnitIdById,
}: UseMultiSelectCellResolutionOptions): (
  ref: MultiSelectCellRef,
) => UnifiedSelectCellResolution | null {
  return React.useCallback(
    (ref: MultiSelectCellRef): UnifiedSelectCellResolution | null =>
      resolveOfferMultiSelectCell(ref, periods, entriesGrid, (unitId) =>
        mediaUnitIdById.get(unitId),
      ),
    [periods, entriesGrid, mediaUnitIdById],
  );
}
